import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.error.cause.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import DropDown from '@/common/dropdown.vue';
import { validatePassWord } from '@/tools/regexp';
import { updatePasswordNew, getCode as _getCode, updateMobileNo, untypingWechat as _untypingWechat } from '@/services/http';
// import { writeCookie } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.validateCheckPass = function (rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== _this.form.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    _this.infoList = {};
    _this.form = {
      oldPassword: '',
      newPassword: '',
      checkPass: ''
    };
    _this.telform = {
      mobileNo: '',
      smsCode: ''
    };
    _this.rules = {
      mobileNo: [{
        required: true,
        message: '请输入电话号码',
        trigger: 'blur'
      }],
      smsCode: [{
        required: true,
        message: '请输入验证码',
        trigger: 'blur'
      }],
      oldPassword: [{
        required: true,
        message: '请输入原密码',
        trigger: 'blur'
      }],
      newPassword: [{
        validator: validatePassWord,
        trigger: 'blur'
      }],
      checkPass: [{
        validator: _this.validateCheckPass,
        trigger: 'blur'
      }]
    };
    _this.dialogVisible = false;
    _this.telDialog = false;
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getUserInfo();
    }
  }, {
    key: "changePassword",
    value: function changePassword() {
      var _this2 = this;
      this.dialogVisible = true;
      this.$nextTick(function () {
        var form = _this2.$refs.form;
        form.resetFields();
        _this2.telform = {
          mobileNo: '',
          smsCode: ''
        };
      });
    }
  }, {
    key: "changeTel",
    value: function changeTel() {
      var _this3 = this;
      this.telDialog = true;
      this.$nextTick(function () {
        var form = _this3.$refs.telform;
        form.resetFields();
        _this3.form = {
          oldPassword: '',
          newPassword: '',
          checkPass: ''
        };
      });
    }
    // 重置密码
  }, {
    key: "setPassword",
    value: function () {
      var _setPassword = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this4 = this;
        var form;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              form = this.$refs.form;
              form.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(valid) {
                  var res;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (!valid) {
                          _context.next = 5;
                          break;
                        }
                        _context.next = 3;
                        return updatePasswordNew(_this4.form);
                      case 3:
                        res = _context.sent;
                        if (res.data.code === 100) {
                          _this4.$message.success('更换密码成功！');
                          _this4.dialogVisible = false;
                          //  this.setUserInfoList();
                          //  writeCookie('accessToken', res.data.data);
                          //  const path: any = this.$route.query.redirect;
                          //  if (path) {
                          //    this.$router.push(path);
                          //  } else {
                          //    this.$router.push('/');
                          //  }
                        } else {
                          _this4.$message.error(res.data.message);
                        }
                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function setPassword() {
        return _setPassword.apply(this, arguments);
      }
      return setPassword;
    }() // 获取个人信息
  }, {
    key: "getUserInfo",
    value: function () {
      var _getUserInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.setUserInfoList();
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getUserInfo() {
        return _getUserInfo.apply(this, arguments);
      }
      return getUserInfo;
    }() // 解绑微信
  }, {
    key: "untypingWechat",
    value: function () {
      var _untypingWechat2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _untypingWechat();
            case 2:
              res = _context4.sent;
              if (res.data.code === 100) {
                this.$message.success('解绑成功');
              } else {
                this.$message.error(res.data.message);
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function untypingWechat() {
        return _untypingWechat2.apply(this, arguments);
      }
      return untypingWechat;
    }() // 绑定手机号码
  }, {
    key: "setTelPhone",
    value: function () {
      var _setTelPhone = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this5 = this;
        var form;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              form = this.$refs.telform;
              form.validate(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(valid) {
                  var res;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!valid) {
                          _context5.next = 5;
                          break;
                        }
                        _context5.next = 3;
                        return updateMobileNo(_this5.telform);
                      case 3:
                        res = _context5.sent;
                        if (res.data.code === 100) {
                          _this5.telDialog = false;
                          _this5.$message.success('绑定手机号码成功！');
                        } else {
                          _this5.$message.error(res.data.message);
                        }
                      case 5:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function setTelPhone() {
        return _setTelPhone.apply(this, arguments);
      }
      return setTelPhone;
    }() // 获取验证码
  }, {
    key: "getCode",
    value: function () {
      var _getCode2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var res;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _getCode({
                phone: this.telform.mobileNo,
                src: 3
              });
            case 2:
              res = _context7.sent;
              if (res.data.code === 100) {
                this.$message.success('手机验证码已经成功发送，请注意查收！');
                // this.endTime = Date.now() + 59 * 1000;
                // this.isCountDown = true;
                // this.clsStyle = false;
              } else {
                this.$message.error(res.data.message);
              }
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getCode() {
        return _getCode2.apply(this, arguments);
      }
      return getCode;
    }()
  }, {
    key: "modifyTelphone",
    value: function () {
      var _modifyTelphone = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var res;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return updateMobileNo({
                mobileNo: '',
                smsCode: ''
              });
            case 2:
              res = _context8.sent;
              if (res.data.code === 100) {
                this.$message.error('绑定手机号码成功！');
                this.$router.back();
              } else {
                this.$message.error(res.data.message);
              }
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function modifyTelphone() {
        return _modifyTelphone.apply(this, arguments);
      }
      return modifyTelphone;
    }()
  }]);
}(Vue);
__decorate([State('user')], default_1.prototype, "userinfor", void 0);
__decorate([Action('user/setUserInfoList')], default_1.prototype, "setUserInfoList", void 0);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Price: Price,
    Footer: Footer,
    DropDown: DropDown,
    NavMenu: NavMenu
  }
})], default_1);
export default default_1;